//Please add the language resource
const addr = {
  addrCode: 'addrCode',
  addrName: 'addrName',
  region: 'region',
  shipperName: 'shipperName',
  companyName: 'companyName',
  useCompanyName: 'useCompanyName',
  provinceCode: 'provinceCode',
  provinceName: 'provinceName',
  cityCode: 'cityCode',
  cityName: 'cityName',
  districtCode: 'districtCode',
  districtName: 'districtName',
  addr: 'addr',
  lat: 'lat',
  lng: 'lng',
  contactMan: 'contactMan',
  contactWay: 'contactWay',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',
  addrType: 'addrType',
};
export default addr



// WEBPACK FOOTER //
// ./src/page/mdm/addr/lang/addr.en.js